<script setup>
  import { useSettingsStore, useTabBarStore } from '@/layouts/sfapp';

  const settingsStore = useSettingsStore();
  const tabBarStore = useTabBarStore();

  // 让子应用能够获取到主应用的tab
  window.$tabStore = tabBarStore;

  if (import.meta.env.DEV) {
    // 开发模式才显示生成代码工具
    const initNewCodeTool = async () => {
      // 按需加载
      const { showNewCodeTool, hideNewCodeTool } = await import('@/layouts/sfapp');

      watch(
        () => settingsStore.settings.layout.hiddenNewCodeTool,
        (hiddenNewCodeTool) => {
          if (!showNewCodeTool || !hideNewCodeTool) return;
          hiddenNewCodeTool ? hideNewCodeTool() : showNewCodeTool();
        },
        { immediate: true },
      );
    };

    initNewCodeTool();
  }
</script>

<template>
  <RouterView></RouterView>
</template>

<style lang="less">
  .TabBarItem {
    .title {
      max-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .tab-bar-container {
    margin-bottom: 16px !important;
  }
</style>
